import GenericReportMobile from '../_partials/GenericReportMobile/GenericReportMobile';
import { useTranslation } from 'react-i18next';
import TopSubscribersTableRowHeadingMobile from './TopSubscribersTableRowHeadingMobile';
import TopSubscribersActionMenu from '../../../TopSubscribersSection/TopSubscribersActionMenu';
import { formatDate, DATE_FORMATS } from '@wix/da-i18next/pkg/time/functions';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import { TimePeriod, TimePeriodOption } from '../../../../../types/reports';

import s from './TopSubscribersMobile.scss';

const PRO_ONLY_DISPLAY_LIMIT = 3;
const INITIAL_VISIBLE_COUNT = 5;

export default function TopSubscribersMobile() {
  const { t } = useTranslation();

  const timePeriodOptions: TimePeriodOption[] = [
    {
      value: TimePeriod.ALL,
      translationKey: `studio.reports.subscriberStates.${TimePeriod.ALL}`,
    },
    {
      value: TimePeriod.ACTIVE,
      translationKey: `studio.reports.subscriberStates.${TimePeriod.ACTIVE}`,
    },
    {
      value: TimePeriod.CANCELLED,
      translationKey: `studio.reports.subscriberStates.${TimePeriod.CANCELLED}`,
    },
    {
      value: TimePeriod.NEW,
      translationKey: `studio.reports.subscriberStates.${TimePeriod.NEW}`,
    },
  ];

  const columns = [
    {
      key: 'firstJoinDate',
      label: t(
        'studio.reports.section.topSubscribers.table.header.firstJoinDate'
      ),
      format: (value: any) =>
        value ? formatDate(value, DATE_FORMATS.Date.Full) : '---',
    },
    {
      key: 'lastCancelDate',
      label: t(
        'studio.reports.section.topSubscribers.table.header.lastCancelDate'
      ),
      format: (value: any) =>
        value ? formatDate(value, DATE_FORMATS.Date.Full) : '---',
    },
    {
      key: 'monthsSubscribed',
      label: t('studio.reports.section.topSubscribers.table.header.cycles'),
    },
    {
      key: 'salesVolume',
      label: t('studio.reports.section.topSubscribers.table.header.sales'),
      format: formatDollars,
    },
  ];

  return (
    <GenericReportMobile
      reportType="topSubscribers"
      headingKey="studio.reports.section.topSubscribers.title"
      descriptionKey="studio.reports.section.topSubscribers.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={t(
              'studio.reports.section.topSubscribers.description.learnMoreLink.url'
            )}
          >
            {t(
              'studio.reports.section.topSubscribers.description.learnMoreLink.text'
            )}
          </a>
        ),
      }}
      columns={columns}
      RowHeading={TopSubscribersTableRowHeadingMobile}
      RowExtras={RowExtrasWrapper}
      proOnlydisplayLimit={PRO_ONLY_DISPLAY_LIMIT}
      initialVisibleCount={INITIAL_VISIBLE_COUNT}
      timePeriodOptions={timePeriodOptions}
    />
  );
}

function RowExtrasWrapper({ item }: { item: any }) {
  return (
    <TopSubscribersActionMenu
      user={item.user}
      wrapperClassName={s['menu-wrapper']}
      expandedActions={false}
    />
  );
}
